import State from "./state";

export const accessTokenSelector = (state: State) => state.user.accessToken;
export const shopSelector = (state: State) => state.shop.activeShop;
